<template>
    <!-- ------------------------------------- 博客 ----------------------------------- -->
    <div class="blog">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <div class="banner">
            <!--      <p>共创·共享·共利</p>-->
        </div>
        <!-- ---------------------------------- 文章 ---------------------------------- -->
        <div class="article">
            <!-- 主文章 -->
            <div class="article_main">
                <!-- 招聘信息 -->
                <div class="article_information">
                    <div>
                        <el-collapse v-model="activeNames">
                            <el-collapse-item title="销售主任" name="1">
                                <div class="neirong">
                                    <div
                                        class="fontSize"
                                        style="
                                            margin-top: 10px;
                                            font-weight: 500;
                                        "
                                    >
                                        蔚诺正寻找<b
                                            class="fontSize24"
                                            style="font-family: Microsoft YaHei">销售主任</b
                                        >，负责室内空气质量检测，产生销售线,
                                        建立销售团队并实现公司销售目标。
                                    </div>
                                    <div
                                        class="fontSize"
                                        style="
                                            margin-top: 20px;
                                            font-weight: 500;
                                        "
                                    >
                                        工作职责:
                                    </div>
                                    <ul
                                        class="fontSize"
                                        style="
                                            font-weight: 500;
                                            margin-left: -1%;
                                        "
                                    >
                                        <li>
                                            跟进小型销售摊位活动及相关的潜在和新客户的查询及销售
                                        </li>
                                        <li>负责市场开发及客户维护等工作</li>
                                        <li>
                                            负责服务及产品宣传、推广和销售，完成销售的任务指标
                                        </li>
                                        <li>
                                            建立销售团队, 培训新入职销售顾问
                                        </li>
                                        <li>
                                            进行空气质量测试，制作销售方案，与潜在客户洽谈合同
                                        </li>
                                        <li>
                                            参加每周会议并准备每周和每月销售工作报告
                                        </li>
                                    </ul>
                                    <div
                                        class="fontSize"
                                        style="font-weight: 500"
                                    >
                                        岗位要求:
                                    </div>
                                    <ul
                                        class="fontSize"
                                        style="
                                            font-weight: 500;
                                            margin-left: -1%;
                                        "
                                    >
                                        <li>需有1-3年营销管理经验</li>
                                        <li>
                                            精通PowerPoint、Word和Excel等软件操作
                                        </li>
                                        <li>较强的口头表达能力及演讲能力</li>
                                        <li>对工作有很强的责任心和热情</li>
                                        <li>目标导向，有一定的抗压力</li>
                                        <li>较强的学习能力</li>
                                        <li>
                                            有电商或空气净化行业等渠道资源者优先
                                        </li>
                                    </ul>
                                    <div
                                        class="fontSize"
                                        style="font-weight: 500"
                                    >
                                        对所述职位感兴趣者，请将简历发送到<sapn
                                            style="
                                                color: #417ddf;
                                                margin-left: 1%;
                                            "
                                            ><a
                                                href="mailto:hr@renaudchina.com"
                                                style="padding-left: 5px"
                                            >
                                                hr@renaudchina.com</a
                                            >.</sapn
                                        >
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <el-collapse>
                        <el-collapse-item title="销售和市场部实习生" name="1">
                            <div class="neirong" style="margin-top: 10px">
                                <div
                                    class="fontSize"
                                    style="margin-top: 20px; font-weight: 500"
                                >
                                    工作职责:
                                </div>
                                <ul
                                    class="fontSize"
                                    style="font-weight: 500; margin-left: -1%"
                                >
                                    <li>
                                        管理公司的社交媒体，包括战略制定、每日发布和线上互动活动
                                    </li>
                                    <li>
                                        制作与公司产品和服务相关的视频和文章
                                    </li>
                                    <li>
                                        通过联系国际学校和其他国际协会寻求市场合作及活动
                                    </li>
                                    <li>
                                        能够使用设计软件，如Photoshop/Illustrator和/或其他视频编辑软件
                                    </li>
                                    <li>
                                        参加销售会议，协助销售部进行空气测试
                                    </li>
                                    <li>了解公司的产品、服务和促销活动</li>

                                    <li>学习CRM系统并每天更新客户信息</li>
                                    <li>
                                        通过电话或电子邮件联系现有客户以推广新产品或服务
                                    </li>
                                    <li>
                                        研究并生成潜在客户和其他销售渠道的列表
                                    </li>
                                    <li>协助销售部下订单，准备报价单和合同</li>
                                    <li>
                                        分析销售数据，提出增加潜在客户和转化率的方法
                                    </li>
                                    <li>在学校和公司活动中代表公司</li>
                                    <li>每周参加一次公司销售和市场部会议</li>
                                </ul>
                                <div style="font-weight: 500" class="fontSize">
                                    对所述职位感兴趣者，请将简历发送到<sapn
                                        style="color: #417ddf; margin-left: 1%"
                                        ><a
                                            href="mailto:hr@renaudchina.com"
                                            style="padding-left: 5px"
                                            >hr@renaudchina.com</a
                                        >.</sapn
                                    >
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                    <!-- <el-collapse>
                        <el-collapse-item title="实习生" name="1">
                            <div class="neirong" style="margin-top:10px;">

                            </div>
                        </el-collapse-item>
                    </el-collapse> -->
                </div>
            </div>
            <!-- 副文章 -->
        </div>
        <!-- ---------------------------------- 分页栏 ---------------------------------- -->
        <!-- <div class="paging">
                <el-pagination
                        background
                        layout=" pager, next"
                        :total="50">
                </el-pagination>
            </div> -->
        <!-- ---------------------------------- 底部栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
export default {
    data() {
        return {
            activeNames: ['1'],
        };
    },
    components: {
        Header,
        Footer,
    },
    methods: {
        // 跳转文章详情
        toBlogDetails() {
            this.$router.push({
                path: '/blogDetails',
            });
        },
    },
};
</script>

<style lang="less" scoped>
.fontSize {
    font-size: 20px;
}
.fontSize24 {
    font-size: 24px;
}
.banner {
    width: 100%;
    height: 687px;
    background: url('../assets/images/banner-pre.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    p {
        font-size: 70px;
        color: #ffffff;
        letter-spacing: 10px;
        font-weight: lighter;
        margin: 0;
        position: absolute;
        bottom: 37%;
        right: 12%;
    }
}
// ---------------------------- 招聘信息 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .article {
        // 主文章
        .article_main {
            width: 85%;
        }
    }
.fontSize{
    font-size: 50px !important;
}    
.fontSize24{
    font-size: 54px !important;
}
    /deep/ .el-collapse-item__header {
        font-size: 82px;
        height: 140px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .article {
        // 主文章
        .article_main {
            width: 55%;
        }
    }
    /deep/ .el-collapse-item__header {
        font-size: 32px;
        height: 60px;
    }
}
.article {
    width: 100%;
    margin: 0 auto;
    padding: 80px 0 60px 0;
    display: flex;
    justify-content: space-between;
    font-family: '等线';
    // 主文章
    .article_main {
        margin: 0 auto;
        // 文章标题
        .article_title {
            border: 1px solid #bcbcbc;
            background: #efeeed;
            // font-weight: 600;
            color: #192c54;
            letter-spacing: 2px;
            margin: 0;
            cursor: pointer;
        }
        // 文章信息
        .article_information {
            width: 100%;
            margin: 10px 0 30px 0;
            .title {
                // font-weight: bold;
            }
            p {
                color: #333;
            }
            .neirong {
                width: 95%;
                margin: auto;
                margin-top: 3%;
                // padding: 0 5%;
            }
        }
    }
}

/deep/ .el-collapse {
    // border: 0.005208rem solid #bcbcbc;
    background: #efeeed;
}
/deep/ .el-collapse-item__header {
    font-family: Microsoft YaHei;
    border-radius: 16px 16px 16px 16px;
    background: #efeeed;
    background: #efeeed;
    font-weight: 600;
    color: #192c54;
    letter-spacing: 2px;
    margin: 0;
    cursor: pointer;
    padding-left: 3%;
}
/deep/ .el-collapse {
    border: 1px solid #bcbcbc;
    border-radius: 16px;
    margin-top: 15px;
}
/deep/ .el-collapse-item__wrap {
    font-size: 18px;
    border-radius: 0 0 16px 16px;
    background: #fafafb;
    font-weight: 600;
    color: #192c54;
    letter-spacing: 2px;
    margin: 0;
    cursor: pointer;
    border-top: 1px solid #bcbcbc;
    padding-left: 1%;
}
</style>



// WEBPACK FOOTER //
// src/view/recruit.vue